export default __webpack_public_path__ + "img/cdbf03e797a0977947ad51cd1ca34b16.png";